import {combineReducers} from "redux";

import populartag from "../features/admin/blogs/populartag/Slice";

import blog from "../features/admin/blogs/blog/Slice";

import getstarted from "../features/admin/blogs/getstarted/Slice";

import common from "../features/admin/common/Slice";

const blogs = combineReducers({
    populartag,
    blog,
    getstarted,
    common
});

export default blogs;